import React from 'react';
import { formatPrintDate, formatSite, MetadataGrid, PrintFooter, PrintHeader, SectionBar, text } from './PrintRecordParts';

export default function PrintRepairForm({ header = {} }) {
  const title = 'Technician Repair';
  const recordId = text(header.recordId);
  const started = formatPrintDate(header.dateStarted);
  const completed = formatPrintDate(header.dateCompleted);
  return <div className="rpf-wrap print-record print-only">
    <PrintHeader title={title} recordId={recordId} timestamp={header.submittedAt || header.dateCompleted} />
    <MetadataGrid cells={[
      { label: 'Customer', value: header.customerName }, { label: 'Site', value: formatSite(header), wide: true },
      { label: 'Unit ID', value: header.unitId }, { label: 'Hour Meter', value: header.hourMeter },
      { label: 'Make / Model', value: [header.make, header.model].filter(Boolean).join(' / ') },
      { label: 'Serial Number', value: header.serialNumber }, { label: 'Performed By', value: header.performedByName || header.technicianName },
      { label: 'Customer PO / Dates', value: [header.po, [started, completed].filter(Boolean).join(' → ')].filter(Boolean).join(' · ') },
    ]} />
    <section className="repair-work-section"><SectionBar>Work Performed / Corrective Action</SectionBar><div className="repair-work-body">{text(header.notes)}</div></section>
    <section className="repair-signoff"><SectionBar>Signed By</SectionBar><div className="print-closing-body print-signature">{text(header.technicianSignature)}{header.performedByName && <small>{header.performedByName}</small>}</div></section>
    <PrintFooter title={title} />
  </div>;
}
